var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamOff28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8995_217911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88388 4.88394C2.39573 4.39578 1.60427 4.39578 1.11612 4.88394C0.627961 5.37209 0.627961 6.16355 1.11612 6.65171L2.39573 7.93131C2.14146 8.45637 2 9.04605 2 9.6651V18.3349C2 20.3437 3.48947 22.0432 5.48965 22.2288C7.02944 22.3717 8.81196 22.5 10.25 22.5C11.688 22.5 13.4706 22.3717 15.0104 22.2288C15.4815 22.1851 15.9242 22.0574 16.3259 21.8615L17.7331 23.2687C18.2213 23.7569 19.0127 23.7569 19.5009 23.2687C19.989 22.7806 19.989 21.9891 19.5009 21.5009L17.6927 19.6928C17.691 19.691 17.6892 19.6892 17.6874 19.6874L4.55683 6.55683C4.55505 6.55505 4.55326 6.55329 4.55147 6.55153L2.88388 4.88394Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1343 15.5988C17.6383 16.1028 18.5 15.7458 18.5 15.0331V9.66511C18.5 7.65634 17.0105 5.95679 15.0104 5.77116C13.4706 5.62826 11.688 5.5 10.25 5.5C9.82912 5.5 9.37874 5.51099 8.91357 5.53011C8.22902 5.55825 7.91969 6.38416 8.40415 6.86862L17.1343 15.5988Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.1324C21 11.4299 21.3686 10.7788 21.971 10.4174L23.9862 9.20826C25.0424 8.57458 26.3815 9.0529 26.625 10.2602C26.8271 11.262 27 12.5445 27 14C27 15.4555 26.8271 16.738 26.625 17.7398C26.3815 18.9471 25.0424 19.4254 23.9862 18.7917L21.971 17.5826C21.3686 17.2212 21 16.5701 21 15.8676V12.1324Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8995_217911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOff28);
export default __webpack_public_path__ + "static/media/cam_off_28.d2cb03f0.svg";
export { ForwardRef as ReactComponent };